"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "layer2",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "m 22.635565,12.68336 v 4.739779 a 2.3471987,1.3542226 0 0 1 -2.3472,1.354224 H 3.8579752 A 2.3471987,1.3542226 0 0 1 1.5107765,17.423139 V 12.68336 m 21.1247885,0 V 7.943582 a 2.3471987,1.3542226 0 0 0 -2.3472,-1.3542226 H 3.8579752 A 2.3471987,1.3542226 0 0 0 1.5107765,7.943582 v 4.739778 m 21.1247885,0 H 1.5107765",
      id: "path905",
      strokeWidth: "2",
      strokeMiterlimit: "4",
      strokeDasharray: "none"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "layer1",
    opacity: "1",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      stroke: "currentColor",
      strokeOpacity: "1",
      fill: "#f9ffff",
      fillOpacity: "1",
      opacity: "1",
      d: "M 22,3 H 2 l 8,9.46 V 19 l 4,2 v -8.54 z",
      id: "polygon895"
    })
  })]
}));